import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { restartSession } from "@/api";
import { useEditorState } from "@/store";
import { RefreshCcw } from "lucide-react";
import timerIconUrl from "./shared/time_over.svg";

const SessionExpiredAlert = () => {
  const { t } = useTranslation();
  const { tokens: { express_api_token: accessToken } = {}, shutDown } = useEditorState();

  useEffect(() => {
    if (shutDown) {
      const coverElement = document.getElementById("cover-screen-expires");

      const onCoverRemoved = () => {
        const htmlElement = document.documentElement;
        if (htmlElement) {
          htmlElement.remove();
        }
      };

      const observer = new MutationObserver((mutationsList: any) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            for (const removedNode of mutation.removedNodes) {
              if (removedNode === coverElement) {
                onCoverRemoved();
                observer.disconnect();
                break;
              }
            }
          }
        }
      });

      observer.observe(coverElement?.parentElement as any, { childList: true });
    }
  }, [shutDown]);

  if (!shutDown) {
    return null;
  }

  return (
    <div
      className="absolute w-screen h-screen top-0 left-0 flex justify-center items-center"
      id="cover-screen-expires"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 999,
      }}
    >
      <div className="flex items-center justify-center p-4">
        <div className="bg-white rounded-[16px] shadow-lg p-10 text-center items-center justify-center border border-gray-50" style={{ minWidth: "520px" }}>

          {/* Icon Header */}
          <div className="flex justify-center mb-2">
            <div className="bg-[#059BCA] p-2 rounded-full shadow-sm">
              <img src={timerIconUrl} alt="Timer" width={45} height={45} />
            </div>
          </div>

          {/* Text Content */}
          <h2 className="text-[#000000] mb-3 tracking-tight" style={{ fontFamily: "'Alata', sans-serif", fontSize: "30px" }}>
            {t("sessionExpired")}
          </h2>

          <div className="flex justify-center">
            <p className="text-[#000000] text-sm mb-7 px-4 w-100  " style={{ fontFamily: "'Alata', sans-serif", fontSize: "18px", lineHeight: "1.1" }}>
              {t("restartSession")}
            </p>
          </div>

          {/* Action Button */}
          <div className="flex justify-center">

            <button
              onClick={async () => {
                await restartSession(accessToken || "");
                window.location.reload();
              }}
              className="group flex items-center justify-center gap-3 w-60 bg-[#05CA75] hover:bg-[#00c270] transition-colors text-white  py-3 px-6 rounded-full text-lg shadow-md active:scale-[0.98]"
            >
              <span style={{ fontFamily: "'Alata', sans-serif", fontSize: "18px" }}>{t("restart")}</span>
              <RefreshCcw className="w-6 h-6 group-hover:rotate-45 transition-transform" />
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SessionExpiredAlert;
